import React, { useState } from "react";
import { FormInstance, Input } from "antd";
import { Image } from "theme-ui";
import { PaymentMethod } from "models";
import { FormField, FormRow } from "components/common/forms";
import { formatCardNumber, formatExpirationDate, formatCVC, getCardType } from "helpers/CreditCardHelper";

type Props = {
  form: FormInstance<PaymentMethod>
}
const CreditCardSection: React.FC<Props> = ({ form }) => {
  const fields = PaymentMethod.Model.fields;
  const [cardType, setCardType] = useState(getCardType(''));

  const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = ev.target.id;
    const value = ev.target.value;
    let formated = '';

    if (fieldName === fields.cardNumber.name) {
      let cardType = getCardType(value);
      formated = formatCardNumber(value, cardType);
      setCardType(cardType);
      form.setFieldsValue({cvc: null});
    }
    if (fieldName === fields.expiry.name) {
      formated = formatExpirationDate(value);
    }
    if (fieldName === fields.cvc.name) {
      formated = formatCVC(value, cardType);
    }
    form.setFieldsValue({ [fieldName]: formated });
  };

  return (
    <>
      <Image src="/assets/credit-cards.png" mb={2} sx={{ height: 20 }} />
      <FormField field={fields.cardNumber}>
        <Input type="tel" onChange={onChange} />
      </FormField>
      <FormRow colSpans={[12, 12]}>
        <FormField field={fields.expiry}>
          <Input type="tel" onChange={onChange} maxLength={5} />
        </FormField>
        <FormField field={fields.cvc}>
          <Input type="tel" onChange={onChange} />
        </FormField>
      </FormRow>
    </>
  );
};

export default CreditCardSection;
